import { error } from "@sveltejs/kit";
import "reflect-metadata";
export const HTTP_METHOD_TOKEN = Symbol("httpMethod");
export const FORM_ACTION_TOKEN = Symbol("formActions");
export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["POST"] = "POST";
    HttpMethod["GET"] = "GET";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["DELETE"] = "DELETE";
})(HttpMethod || (HttpMethod = {}));
// When using Get/Post/Put/Delete/Patch
// always start with "/"
// i.e. @Get("/name")
/** Makes the method a GET request handler. */
// export function Get(path?: string): MethodDecorator {
//   return applyHttpMethod({ method: HttpMethod.GET, path: getPath(path) });
// }
// /** Makes the method a POST request handler. */
// export function Post(path?: string): MethodDecorator {
//   return applyHttpMethod({ method: HttpMethod.POST, path: getPath(path) });
// }
// /** Makes the method a PUT request handler. */
// export function Put(path?: string): MethodDecorator {
//   return applyHttpMethod({ method: HttpMethod.PUT, path: getPath(path) });
// }
// /** Makes the method a DELETE request handler. */
// export function Delete(path?: string): MethodDecorator {
//   return applyHttpMethod({ method: HttpMethod.DELETE, path: getPath(path) });
// }
// /** Makes the method a PATCH request handler. */
// export function Patch(path?: string): MethodDecorator {
//   return applyHttpMethod({ method: HttpMethod.PATCH, path: getPath(path) });
// }
// When using actions do not start with /
// @Action("name") <--- valid
// @Action("/name") <--- error
/**
 *  @Action("name") <--- valid
 *  @Action("/name") <--- error
 *  @remarks((input:RequestEvent,payload:Record<string,string>)=>Promise)
 * */
export function Action(action) {
    return (target, propertyKey, descriptor) => {
        var _a;
        //setting up for later createFormHandler
        const actionNames = (_a = Reflect.getMetadata(FORM_ACTION_TOKEN, target.constructor)) !== null && _a !== void 0 ? _a : new Map();
        if (actionNames.has(action)) {
            error(400, "duplicate action names");
        }
        actionNames.set(action, propertyKey);
        Reflect.defineMetadata(FORM_ACTION_TOKEN, actionNames, target.constructor);
        return descriptor;
    };
}
// function applyHttpMethod({ method, path: inputPath }: { method: HttpMethod; path: string }) {
//   return (target: any, propertyKey: string | symbol, descriptor: TypedPropertyDescriptor<any>) => {
//     // multi-key mapping, can it be made? yes, worth the time? // TODO
//     const methods: Map<string, HandlerMethod> =
//       Reflect.getMetadata(HTTP_METHOD_TOKEN, target.constructor, method) ?? new Map();
//     const keys: string[] = [];
//     const pattern = genRegExp(inputPath, keys); // @TODO create our regular expression parser
//     const indexOfCaptureAll = keys.findIndex(key => key.indexOf("...") === 0);
//     if (indexOfCaptureAll !== -1 && indexOfCaptureAll !== keys.length - 1) {
//       error(400, `..path is reserved to be at the `);
//     }
//     const keysTrimmed = new Set(keys);
//     if (keys.length !== keysTrimmed.size) {
//       error(400, `Can't have multiple of the keyword in your path`);
//     }
//     if (keysTrimmed.has("oldParams")) {
//       error(400, `Reserved Keyword: In Case for access to old/original params`);
//     }
//     if (methods.has(inputPath)) {
//       // Ignore and override if exist - this error happens when in dev mode with hot reload extending a base class
//       console.warn(
//         `WARNING => duplicate path for method ${method} in class ${target.constructor.name}, inputPath of ${inputPath}`
//       );
//       // throw error(
//       //   400,
//       //   `duplicate path for method ${method} in class ${target.constructor.name}, inputPath of ${inputPath}`
//       // );
//     }
//     methods.set(inputPath, { path: inputPath, method, propertyKey, pattern, keys });
//     Reflect.defineMetadata(HTTP_METHOD_TOKEN, methods, target.constructor, method);
//     return descriptor;
//   };
// }
function getPath(pathOrOptions) {
    return typeof pathOrOptions === "string" ? pathOrOptions : "";
}
// path to regular expression generator,, takes /:any, and generates regex matcher pattern
// const varPatternSingle = "[^\\/#\\?]+?";
// const varPatternWithSlash = `(?:\\/(${varPatternSingle}))`;
// const pathMatch = /\[(\.{3}\w+)\]/;
// const pathWithSlash = `(?:\\/([^#\\?]+))`;
// function genRegExp(inputPath: string, keys?: string[]) {
//   const result = ["^"];
//   inputPath.split("/").map(v => {
//     let m = pathMatch.exec(v);
//     if (m) {
//       keys && keys.push(m[1]);
//       result.push(pathWithSlash);
//     } else if (v.length === 0) {
//       result.push("");
//     } else if (v.charAt(0) === ":") {
//       keys && keys.push(v.substring(1));
//       result.push(varPatternWithSlash);
//     } else if (v === "*") {
//       result.push(varPatternWithSlash);
//     } else {
//       result.push("\\/" + v);
//     }
//   });
//   result.push("[\\/#\\?]?$");
//   return new RegExp(result.join(""));
// }
/// NEW
export function Get(path) {
    return (target, propertyKey) => {
        Reflect.defineMetadata("httpMethod", HttpMethod.GET, target, propertyKey);
        Reflect.defineMetadata("path", getPath(path), target, propertyKey);
    };
}
/** Makes the method a POST request handler. */
export function Post(path) {
    return (target, propertyKey) => {
        Reflect.defineMetadata("httpMethod", HttpMethod.POST, target, propertyKey);
        Reflect.defineMetadata("path", getPath(path), target, propertyKey);
    };
}
/** Makes the method a PUT request handler. */
export function Put(path) {
    return (target, propertyKey) => {
        Reflect.defineMetadata("httpMethod", HttpMethod.PUT, target, propertyKey);
        Reflect.defineMetadata("path", getPath(path), target, propertyKey);
    };
}
/** Makes the method a DELETE request handler. */
export function Delete(path) {
    return (target, propertyKey) => {
        Reflect.defineMetadata("httpMethod", HttpMethod.DELETE, target, propertyKey);
        Reflect.defineMetadata("path", getPath(path), target, propertyKey);
    };
}
/** Makes the method a PATCH request handler. */
export function Patch(path) {
    return (target, propertyKey) => {
        Reflect.defineMetadata("httpMethod", HttpMethod.PATCH, target, propertyKey);
        Reflect.defineMetadata("path", getPath(path), target, propertyKey);
    };
}
